import { api } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { Badge, Card, EmptyState, ErrorAlert, PageHeader, Spinner, StatCard } from '../components/ui';

export function CostsPage() {
  const summary = useAsync(() => api.costSummary(), []);
  const generations = useAsync(() => api.generations(50), []);

  const fmtUsd = (value: number) => `$${value.toFixed(6)}`;

  return (
    <>
      <PageHeader title="Costs" subtitle="Koszty generowania AI: tokeny i estymacja kosztów per model." />

      {summary.loading && <Spinner />}
      {summary.error ? <ErrorAlert error={summary.error} /> : null}
      {summary.data && (
        <div className="stack">
          <div className="grid grid--stats">
            <StatCard value={fmtUsd(summary.data.totalCost)} label="Szacowany koszt (USD)" />
            <StatCard value={summary.data.totalGenerations} label="Generacji" />
          </div>
          {summary.data.byProvider.length > 0 ? (
            <Card title="Koszty per provider" flush>
              <table className="table">
                <thead>
                  <tr>
                    <th>Provider</th>
                    <th>Generacji</th>
                    <th>Koszt</th>
                  </tr>
                </thead>
                <tbody>
                  {summary.data.byProvider.map((p) => (
                    <tr key={p.providerKey}>
                      <td className="mono" style={{ fontWeight: 550 }}>
                        {p.providerKey}
                      </td>
                      <td>{p.count}</td>
                      <td>{fmtUsd(p.cost)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Card>
          ) : (
            <p className="muted">Brak wygenerowanych treści — koszty pojawią się po pierwszej generacji przez realny provider.</p>
          )}
        </div>
      )}

      <div style={{ marginTop: 20 }}>
        <h2>Ostatnie generacje</h2>
        {generations.loading && <Spinner />}
        {generations.error ? <ErrorAlert error={generations.error} /> : null}
        {generations.data && generations.data.length === 0 && <EmptyState icon="₿" title="Brak rekordów generacji" />}
        {generations.data && generations.data.length > 0 && (
          <Card flush>
            <table className="table">
              <thead>
                <tr>
                  <th>Provider</th>
                  <th>Model</th>
                  <th>Typ</th>
                  <th>Tokeny in/out</th>
                  <th>Koszt</th>
                  <th>Czas</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {generations.data.map((g) => (
                  <tr key={g.id}>
                    <td className="mono">{g.providerKey}</td>
                    <td className="mono">{g.modelId ?? '—'}</td>
                    <td>
                      <Badge tone="neutral">{g.type}</Badge>
                    </td>
                    <td className="muted">
                      {g.inputTokens ?? 0} / {g.outputTokens ?? 0}
                    </td>
                    <td>{fmtUsd(g.estimatedCost ?? 0)}</td>
                    <td className="muted">{g.durationMs ? `${g.durationMs}ms` : '—'}</td>
                    <td>
                      <Badge tone={g.status === 'SUCCESS' ? 'success' : 'danger'}>{g.status}</Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        )}
      </div>
    </>
  );
}